import { render, staticRenderFns } from "./TopbarLinkGroup.vue?vue&type=template&id=347f905b"
import script from "./TopbarLinkGroup.vue?vue&type=script&lang=js"
export * from "./TopbarLinkGroup.vue?vue&type=script&lang=js"
import style0 from "./TopbarLinkGroup.vue?vue&type=style&index=0&id=347f905b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports